import type { PayloadFormatter } from '../shared/types';
import { normalizeHttpHeaders } from '@terra/shared-utils';

export const formatHttpPayload: PayloadFormatter = (args) => {
  const lines: string[] = [];
  const opts = (args.options || {}) as Record<string, unknown>;
  const method = (opts.method as string) || 'GET';

  if (args.url) {
    lines.push(`**${method}** \`${args.url}\``);
  }

  if (args.credentialId) {
    lines.push(`**Credential:** \`${args.credentialId}\``);
  }

  const headers = opts.headers as Record<string, unknown> | undefined;
  if (headers && Object.keys(headers).length > 0) {
    const normalizedHeaders = normalizeHttpHeaders(
      Object.fromEntries(
        Object.entries(headers).map(([key, value]) => [
          key,
          Array.isArray(value)
            ? value.map(String).join(', ')
            : String(value ?? ''),
        ]),
      ),
    );
    lines.push('\n**Headers:**');
    Object.entries(normalizedHeaders).forEach(([key, value]) => {
      const displayValue =
        typeof value === 'string' && value.length > 50
          ? value.substring(0, 47) + '...'
          : Array.isArray(value)
            ? value.join(', ')
            : value;
      lines.push(`- \`${key}\`: \`${displayValue}\``);
    });
  }

  if (opts.body) {
    lines.push('\n**Body:**');
    try {
      const parsed =
        typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
      lines.push(`\`\`\`json\n${JSON.stringify(parsed, null, 2)}\n\`\`\``);
    } catch {
      lines.push(`\`\`\`\n${opts.body}\n\`\`\``);
    }
  }

  if (opts.formData) {
    lines.push('\n**Form Data:**');
    lines.push(`\`${opts.formData}\``);
  }

  return lines.length > 0 ? lines.join('\n') : null;
};
